import { useState } from "react";
import { Button, Card, CardBody, Col } from "reactstrap";
import { ContactFilter } from "../../../../constants";
import { ContactSidebarProps } from "../../../../types/Applications";
import ContactOptions from "./ContactOptions";
import { dynamicImage } from "../../../../utils";
import { Image } from "../../../../coreComponents/Image";

// Sidebar component for displaying user info and contact options.
const Sidebar: React.FC<ContactSidebarProps> = ({ activeTab, setActiveTab, changeTab }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Col xl="3" className="box-col-6">
      <div className="md-sidebar">
        <Button color="primary" className="md-sidebar-toggle" onClick={() => setIsOpen(!isOpen)}>{ContactFilter}</Button>
        <div className={`md-sidebar-aside job-left-aside custom-scrollbar ${isOpen ? "open" : ""}`}>
          <div className="mail-left-bar">
            <Card>
              <CardBody>
                <div className="message-sidebar left-bookmark">
                  <div className="d-flex">
                    <div>
                      <Image className="rounded-circle me-3" src={dynamicImage(`user/user.png`)} alt="" />
                    </div>
                    <div className="flex-grow-1">
                      <h4>{"MARK JENCO"}</h4>
                      <p>{"Markjecno@gmail.com"}</p>
                    </div>
                  </div>
                  <ContactOptions activeTab={activeTab} setActiveTab={setActiveTab} changeTab={changeTab} />
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </Col>
  );
};
export default Sidebar;